import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders the question form and handles submission via parent callback.
 * Shared component used by YesNoOracleWidget and PendulumOracle.
 */
export default function QuestionForm({ value, onChange, onSubmit, isLoading, isDisabled, placeholder, submitLabel, loadingLabel }) {
  return (
    <form
      className="space-y-3 w-full"
      onSubmit={(event) => {
        event.preventDefault();
        if (!isDisabled && !isLoading) {
          onSubmit(value);
        }
      }}
    >
      <input
        type="text"
        className="w-full p-3 rounded-lg bg-[#1a182c] text-[#FBFBFE] placeholder-gray-500 border border-[#6A3683]/60 focus:outline-none focus:border-[#A45DE8] focus:ring-1 focus:ring-[#A45DE8]/50 transition duration-200 disabled:opacity-50"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        disabled={isDisabled || isLoading}
        data-testid="oracle-question-input"
      />
      <button
        type="submit"
        disabled={isDisabled || isLoading}
        data-testid="submit-button"
        className="w-full py-3 rounded-lg bg-linear-to-r from-[#6A3683] to-[#A45DE8] text-[#FBFBFE] font-semibold shadow-md hover:from-[#7b43a0] hover:to-[#b774f4] disabled:opacity-60 transition-colors"
      >
        {isLoading ? loadingLabel : submitLabel}
      </button>
    </form>
  );
}

QuestionForm.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  placeholder: PropTypes.string,
  submitLabel: PropTypes.string,
  loadingLabel: PropTypes.string,
};

QuestionForm.defaultProps = {
  isLoading: false,
  isDisabled: false,
  placeholder: 'Write your question…',
  submitLabel: 'Reveal Oracle Whisper',
  loadingLabel: 'Consulting the Oracle…',
};

